import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import ReactPaginate from "react-paginate";
import "./pagination.css";
import "./table.css"
import moment from "moment"
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
// styling
import Style from 'assets/jss/material-dashboard-pro-react/views/activityStyle';
import withStyles from '@material-ui/core/styles/withStyles';

// icons
import ArrowRight from "@material-ui/icons/ArrowRight";
import ArrowLeft from "@material-ui/icons/ArrowLeft";

// core components
import { Card, Typography } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import GridItem from 'components/Grid/GridItem';
import { zip } from 'lodash';
import { ptsFormula } from 'globalCalculationFunction/globalCalculationFunction';

export function MobileTable(props) {
    const {
        classes,
        history,
        headers,
        batchData,
        pageNumber,
        setPageNumber,
        index,
        setIndex,
        endIndex,
        setEndIndex,
        itemsPerPage,
        docId,
        user
    } = props;

    const [points, setPoints] = useState([])

    useEffect(() => {
        setEndIndex(itemsPerPage)
    }, [])

    const handlePageClick = ({ selected }) => {
        setPageNumber(selected);
        setIndex(selected * itemsPerPage);
        setEndIndex(selected * itemsPerPage + itemsPerPage);
    };

    useEffect(() => {
        setPoints([])
        batchData.map((d) => {
            const floorDollarPerBassisPts = ptsFormula(d.netAmount, user.userBasisPts)
            setPoints(prevArr => [...prevArr, floorDollarPerBassisPts])
        })
    }, [batchData])

    useEffect(() => {
        batchData.slice(index, endIndex);
    }, [index]);

    const renderTableHeader = () => {
        return (
            <Tr
                className={classes.tableRow}
                style={{
                    height: "38px",
                    border: "1px solid #8E8E8E",
                }}
            >
                {headers.map((key, index) => {
                    return (
                        <Th
                            className={classes.tableHeaders}
                            key={index}>
                            {key.label}
                        </Th>
                    );
                })}
            </Tr>
        );
    };

    const renderTableData = () => {
        let data = zip(batchData, points)
        return data
            .slice(
                pageNumber * itemsPerPage,
                pageNumber * itemsPerPage + itemsPerPage
            )
            .map((d, index) => {
                return (
                    <Tr key={index}>
                        <Td
                            className={classes.tableCell}
                        >
                            <span className={classes.spanHover}
                                onClick={() => {
                                    if (user.IsoAdminCompanyName) {
                                        history.push(`/iso-merchant/${(user.IsoAdminCompanyName).replace(/ /g, '').toLowerCase()}/${(user.companyName).replace(/ /g, '').toLowerCase()}/reports/batch/${docId}/${d[0].docId}`)
                                    } else {
                                        history.push(`/merchant/reports/batch/${docId}/${d[0].docId}`)
                                    }

                                }}
                            >
                                {moment(d[0].reportDate).format("MM/DD/YYYY")}
                            </span>
                        </Td>
                        <Td className={classes.tableCell}>{d[0].transactionCount}</Td>
                        <Td className={classes.tableCell}>{Number(d[0].netAmount).toFixed(2)}</Td>
                        <Td className={classes.tableCell}>{d[0].batchNumber}</Td>
                        <Td className={classes.tableCell} style={{ fontWeight: 700 }}>{d[1]} pts</Td>
                    </Tr>
                );
            });
    };

    return (
        <Card className={classes.card} style={{marginTop:"0px"}}>
            <GridContainer>
                <GridItem xs={12}>
                    <Typography className={classes.cardDescMobile}>
                        Your Earning History
                    </Typography>
                </GridItem>

                <GridItem xs={12}>
                    <Typography className={classes.cardDescSmall} >
                        Your points earned on everyday transactions will show here.
                    </Typography>
                </GridItem>



                <GridItem xs={12}>
                    <Table className={classes.reportsTable} style={{ marginBottom: "10px", marginTop: "10px" }}>
                        <Thead>
                            {renderTableHeader()}
                        </Thead>
                        <Tbody>
                            {renderTableData()}
                        </Tbody>
                    </Table>
                    <GridContainer style={{ marginBottom: "-20px" }}>
                        <GridItem xs={8} style={{ marginTop: "5px", display: "flex", justifyContent: "flex-end" }}>
                            <h5
                                className={classes.indexesMobile}
                            >
                                {index + 1} of {" "}
                                {batchData.length}
                            </h5>
                        </GridItem>
                        <GridItem xs={4}>
                            <ReactPaginate
                                paginationSize={0}
                                onPageChange={handlePageClick}
                                pageCount={Math.ceil(batchData.length / itemsPerPage)}
                                nextLabel={
                                    <ArrowRight
                                        style={{
                                            fontSize: 25,
                                            fontWeight: "bold",
                                            color: "white",
                                        }}
                                    />
                                }
                                previousLabel={
                                    <ArrowLeft
                                        style={{
                                            fontSize: 25,
                                            fontWeight: "bold",
                                            color: "white",
                                        }}
                                    />
                                }
                                containerClassName={"paginationBttns"}
                                previousLinkClassName={"previousBttn"}
                                nextLinkClassName={"nextBttn"}
                                disabledClassName={"paginationDisabled"}
                                activeClassName={"paginationActive"}
                            />
                        </GridItem>
                    </GridContainer>

                </GridItem>
            </GridContainer>
        </Card>
    )
}

function mapStateToProps(state) {
    return {
        user: state.auth.user,
        userId: state.auth.user.uid
    };
}

function mapDispatchToProps(actions) {
    return (dispatch) => ({

    });
}

export default withRouter(compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(MobileTable));